<template>
  <section class="container">
    <div class="top_box">
      <News :list="topnews"></News>
    </div>
    <ul>
      <li v-for="item in news.list" :key="item.id">
        <div class="left">
          <img :src="$baseURL + item.thumb" alt="" />
          <div class="date">
            {{ item.posttime }}
          </div>
        </div>
        <div class="right">
          <h5>{{ item.title }}</h5>
          <p class="dh_text2">{{ item.description }}</p>

          <router-link class="more iconfont icon-jiantou b"
            :to="{ path: '/news/info', query: { id: item.id } }">More</router-link>
        </div>
      </li>
      <Loading v-show="loading"></Loading>
    </ul>

    <Pages v-if="news.list.length" @numberChange="numberChange" :last="news.page_count"></Pages>
  </section>
</template>

<script>
import News from "@/components/home/news.vue";
import image from "@/assets/image/news.png";
import service from "@/assets/js/service";

export default {
  data() {
    return {
      loading: false,
      cid: this.$route.query.cid,
      page: 1,
      list: [
        {
          image,
          title: "AGV小车生产厂家介绍AGV小车在自动化立体仓库中的优势",
          descript:
            "AGV小车在现在话、智能化物流运输中起着非常关键的作用，经常应用于各种生产运输的项目之中，帮助众多企业减少了人力成本，提高了工作效率，高效便捷。AGV小车还被普遍应用于电子、机械、仓储、运输...",
          mon: 6,
          date: 28,
          id: 14,
        },
        {
          image,
          title: "AGV小车生产厂家介绍AGV小车在自动化立体仓库中的优势",
          descript:
            "AGV小车在现在话、智能化物流运输中起着非常关键的作用，经常应用于各种生产运输的项目之中，帮助众多企业减少了人力成本，提高了工作效率，高效便捷。AGV小车还被普遍应用于电子、机械、仓储、运输...",
          mon: 6,
          date: 28,
          id: 14,
        },
        {
          image,
          title: "AGV小车生产厂家介绍AGV小车在自动化立体仓库中的优势",
          descript:
            "AGV小车在现在话、智能化物流运输中起着非常关键的作用，经常应用于各种生产运输的项目之中，帮助众多企业减少了人力成本，提高了工作效率，高效便捷。AGV小车还被普遍应用于电子、机械、仓储、运输...",
          mon: 6,
          date: 28,
          id: 14,
        },
        {
          image,
          title: "AGV小车生产厂家介绍AGV小车在自动化立体仓库中的优势",
          descript:
            "AGV小车在现在话、智能化物流运输中起着非常关键的作用，经常应用于各种生产运输的项目之中，帮助众多企业减少了人力成本，提高了工作效率，高效便捷。AGV小车还被普遍应用于电子、机械、仓储、运输...",
          mon: 6,
          date: 28,
          id: 14,
        },
        {
          image,
          title: "AGV小车生产厂家介绍AGV小车在自动化立体仓库中的优势",
          descript:
            "AGV小车在现在话、智能化物流运输中起着非常关键的作用，经常应用于各种生产运输的项目之中，帮助众多企业减少了人力成本，提高了工作效率，高效便捷。AGV小车还被普遍应用于电子、机械、仓储、运输...",
          mon: 6,
          date: 28,
          id: 14,
        },
      ],
      topnews: [],
      news: {
        page_count: 1,
        list: [],
      },
    };
  },
  created() {
    this.newsIndex();
  },
  methods: {
    async newsIndex() {
      this.loading = true;
      let res = await service.newsIndex({ cid: this.cid, page: this.page });
      this.loading = false;
      if (res.code == 1) {
        this.topnews = res.data.topnews;
        this.news = res.data.news;
      }
    },
    numberChange(number) {
      this.page = number;
    },
  },
  components: { News },
  watch: {
    $route(to, from) {
      this.cid = to.query.cid;
    },
    page() {
      this.newsIndex();
    },
    cid() {
      this.newsIndex();
    },
  },
};
</script>


<style lang="less" scoped>
.top_box {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 73, 152, 0.08);
}

ul {
  margin-top: 30px;
  position: relative;

  li {
    display: flex;
    transition: all 0.3s;
    border-radius: 10px;
    overflow: hidden;

    .left {
      width: 30%;
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        transition: all 0.3s;
      }

      .date {
        position: absolute;
        right: 0;
        top: 10%;
        background: #fff;
        padding: 7px 10px;
        font-size: 14px;
        color: #666;
        line-height: 1;
        transition: all 0.3s;

        b {
          font-size: 26px;
          color: #333;
          transition: all 0.3s;
        }
      }
    }

    .right {
      flex: 1;
      padding-left: 55px;
      padding-top: 30px;
      border-bottom: 1px solid #ddd;
      position: relative;

      h5 {
        font-size: 20px;
        font-weight: 400;
        transition: all 0.3s;
      }

      p {
        color: #999;
        margin: 10px auto 45px;
      }

      .more {
        margin-bottom: 10px;
      }

      &::after {
        content: "";
        width: 0;
        height: 1px;
        background: var(--themeColor2);
        position: absolute;
        bottom: 0;
        right: 0;
        transition: all 0.3s;
      }
    }

    &+li {
      margin-top: 20px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 20px rgba(0, 73, 152, 0.08);

      .left {
        img {
          transform: scale(1.1);
        }

        .date {
          color: var(--themeColor2);

          b {
            color: var(--themeColor2);
          }
        }
      }

      .right {
        h5 {
          color: var(--themeColor2);
        }

        &::after {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 750px) {
  ul {
    li {
      .left {
        width: 35%;
      }

      .right {
        padding-left: 20px;
      }
    }
  }
}

@media (max-width: 500px) {
  ul {
    li {
      display: block;

      .left {
        width: 100%;
      }

      .right {
        padding: 10px 5px 0;
      }
    }
  }
}
</style>